import type { Agent, Entity, Persisted } from '@tunasong/schemas'
import { isAgent } from '@tunasong/schemas'
import { entitiesApi } from '@tunasong/redux'
import type { RootState, TunaThunkDispatch } from '@tunasong/redux'

interface FindAgentsProps {
  parentId: string
  getState: () => unknown
  dispatch: TunaThunkDispatch
}

/**
 * Return all agent children of `parentId`. Reads the RTK Query cache first
 * (synchronous, free). Falls back to dispatching `loadChildEntities` when
 * the cache is cold.
 */
export const findAgents = async ({ parentId, getState, dispatch }: FindAgentsProps): Promise<Persisted<Agent>[]> => {
  const cached = entitiesApi.endpoints.loadChildEntities.select({ parentId })(getState() as RootState)

  if (cached?.data) {
    return cached.data.filter(isAgent) as Persisted<Agent>[]
  }

  const children = await dispatch(entitiesApi.endpoints.loadChildEntities.initiate({ parentId })).unwrap()

  return (children as Persisted<Entity>[]).filter(isAgent) as Persisted<Agent>[]
}
